var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSquareRightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 9,
    viewBox: "0 0 7 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 4.5L0.25 8.39711L0.25 0.602885L7 4.5Z",
    fill: "#DC0202"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareRightIcon);
export default __webpack_public_path__ + "static/media/square-right-icon.3d472d9d7086ed40247eb27cf20c0cff.svg";
export { ForwardRef as ReactComponent };